import DespachoPage from "./despacho/pages/DespachoPage";

export default function DespachoMunicipal() {
  return <DespachoPage />;
}